module.exports = __webpack_public_path__ + "static/olive-kitteridge-1256efe4c56b6ddb720a25614ebb0b8a.jpg";